import { render } from "./ConsultaRechazados.vue?vue&type=template&id=97b984c0"
import script from "./ConsultaRechazados.vue?vue&type=script&lang=js"
export * from "./ConsultaRechazados.vue?vue&type=script&lang=js"

import "./ConsultaRechazados.vue?vue&type=style&index=0&id=97b984c0&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/cn-chatbot-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__